import { androidPermissions, defaultUpiTimeout, UpiAccountTypes } from 'constants/upiConstants';
import {
	ISimDetailsObject,
	IUpiProfileDetails,
	INativeSupport,
	IUserBank,
	IUpiComplaintDetail,
	ICollectRequest,
	ICollectRequestDetails,
} from 'types';
import { getAppInfo } from './nativeSupport';
import { IObjectType } from './classNames';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';

export const sendRawNativeData = (nativeData: INativeSupport) => {
	console.log('nativeHookCalled:', nativeData);

	if (Reflect.has(window, 'androidObj') && Reflect.has(window.androidObj, 'nativeSupport')) {
		const nativeObj = Reflect.get(window, 'androidObj');
		nativeObj.nativeSupport(JSON.stringify(nativeData));
	}
};

export const sendRawNativeDataUpi = async (nativeData: INativeSupport, resolve: any, reject: any, timeout?: number) => {
	console.log('nativeHookCalled:', nativeData);
	if (Reflect.has(window, 'androidObj') && Reflect.has(window.androidObj, 'nativeSupport')) {
		const nativeObj = Reflect.get(window, 'androidObj');
		nativeObj.nativeSupport(JSON.stringify(nativeData));
	}
};

export const fetchUpiReactivationStatus = () => {
	return new Promise((resolve, reject) => {
		window.onReactivateStatusFetchedSuccessfully = (state: string, status: any) => {
			console.log('state status', state, status);
			if (state) {
				resolve({
					state,
					status,
				});
			} else {
				reject({ error: 'Error in fetching reactivation status' });
			}
		};
		window.onReactivateStatusFetchFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '150';
		sendRawNativeDataUpi(nativeData, resolve, reject);
	});
};

export const fetchDeviceBindedStatus = () => {
	return new Promise((resolve, reject) => {
		window.onDeviceBindStatusFetchedSuccessfully = (status: boolean, simDetails: string) => {
			const simList: ISimDetailsObject[] = simDetails && JSON.parse(simDetails);
			console.log('simList', simList);
			console.log('binding status', status);
			resolve({
				initiate_device_binding: status,
				simsList: simList,
			});
		};
		window.onDeviceBindStatusFetchFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '151';
		sendRawNativeDataUpi(nativeData, resolve, reject);
	});
};

export const fetchInitTpapSdkStatus = (
	forceDeviceBinding: boolean,
	userMobile: string,
	selectedSimData?: ISimDetailsObject,
	callback?: (data: any) => void,
) => {
	return new Promise((resolve, reject) => {
		window.onSDKInitialised = (success: boolean, profileId: string) => {
			console.log('profileId', profileId);
			console.log('success', success);
			resolve({ bindingComplete: success, profileId: profileId });
		};
		window.onInitSdkStatusUpdated = (state: string, error: string, errorCode: string) => {
			console.log('state binding', state);
			callback?.({ state, error, errorCode });
			if (error || errorCode) {
				console.log('error: ', error, 'errorCode:', errorCode);
				reject({ error: error, errorCode: errorCode });
			}
		};
		const nativeData: any = {
			key: '152',
			permission: androidPermissions,
			forceDeviceBinding: forceDeviceBinding,
			mobile: userMobile,
		};
		if (selectedSimData) {
			const { slot, carrier_name } = selectedSimData;
			nativeData.simSlotIndex = slot;
			nativeData.operatorName = carrier_name;
		}
		sendRawNativeDataUpi(nativeData, resolve, reject);
	});
};

export const fetchUpiProfile = (profileId: string) => {
	return new Promise((resolve, reject) => {
		window.onProfileDetailsFetchedSuccessfully = (profileDetails: string) => {
			console.log('profileDetails', profileDetails);
			const upiProfile: IUpiProfileDetails = profileDetails && JSON.parse(profileDetails);
			resolve({
				profileDetails: upiProfile,
			});
		};
		window.onProfileDetailsFetchFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '153';
		nativeData.profileId = profileId || '';
		sendRawNativeDataUpi(nativeData, resolve, reject, defaultUpiTimeout);
	});
};

export const UPIBankList = (accountFlag?: UpiAccountTypes) => {
	return new Promise((resolve, reject) => {
		window.onListOfBanksFetchedSuccessfully = (data: any) => {
			console.log('bankList', data);
			const bankList = data && JSON.parse(data);

			if (bankList) {
				resolve({
					data: bankList,
				});
			} else {
				reject({ error: 'Error in fetching bank lists' });
			}
		};
		window.onListOfBanksFetchFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '154';
		nativeData.accountFlag = accountFlag || UpiAccountTypes.DEBIT;
		sendRawNativeData(nativeData);
	});
};

export const UPISelectedBankList = (bankId: string, mandateAppId: string, accountFlag?: UpiAccountTypes) => {
	return new Promise((resolve, reject) => {
		window.onListOfAccountsFetchedSuccessfully = (success: boolean, accountData: any) => {
			const userBank = accountData && JSON.parse(accountData);
			console.log(accountData);
			if (success) {
				resolve({
					success: success,
					bankData: userBank,
				});
			} else {
				reject('Error in fetching reactivation status');
			}
		};
		window.onListOfAccountsFetchFailed = (error: string, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '155';
		nativeData.selectedBankId = bankId;
		nativeData.linkType = 'MOBILE';
		nativeData.aadharrCons = 'N';
		nativeData.mandateAppId = mandateAppId;
		nativeData.accountFlag = accountFlag || UpiAccountTypes.DEBIT;
		sendRawNativeData(nativeData);
	});
};

export const userBankAccountSave = (
	selectedAccount: any,
	vpa: string,
	accountProviderId: string,
	userReferenceId: string,
) => {
	return new Promise((resolve, reject) => {
		window.onAccountAddedSuccessfully = (success: any) => {
			if (success) {
				resolve(success);
			} else {
				reject({ error: 'something went wrong!' });
			}
		};

		window.onAccountAddFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '156';
		nativeData.selectedAccount = selectedAccount;
		nativeData.vpa = vpa;
		nativeData.accountProviderId = accountProviderId;
		nativeData.userReferenceId = userReferenceId;
		sendRawNativeDataUpi(nativeData, resolve, reject, defaultUpiTimeout);
	});
};

export const UPIActivateAccount = (bankData: IUserBank) => {
	return new Promise((resolve, reject) => {
		window.callbackReclaimSuccess = () => {
			console.log('Reclaim successfull');
			resolve(true);
		};
		window.callbackReclaimFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '164';
		nativeData.selectedAccount = bankData;
		sendRawNativeData(nativeData);
	});
};

export const UPICheckBalance = (bankData: IUserBank) => {
	return new Promise((resolve, reject) => {
		window.callbackCLRequestSubmitted = (string: any) => {
			console.log(string);
		};

		window.callbackCheckBalanceSuccess = (amount: string) => {
			const bankAmount = amount && JSON.parse(amount);

			if (bankAmount) {
				console.log(bankAmount);
				resolve(bankAmount);
			} else {
				reject('Error in fetching reactivation status');
			}
		};
		window.callbackCheckBalanceFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '157';
		nativeData.selectedAccount = bankData;
		sendRawNativeData(nativeData);
	});
};

export const forgetUPIPin = (bankData: IUserBank) => {
	return new Promise((resolve, reject) => {
		window.callbackForgetPinSuccess = () => {
			console.log('forget UPI pin success');
			resolve(true);
		};
		window.callbackForgetPinFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '158';
		nativeData.selectedAccount = bankData;
		sendRawNativeData(nativeData);
	});
};

export const ChangeUPIPin = (bankData: IUserBank) => {
	return new Promise((resolve, reject) => {
		window.callbackChangePinSuccess = () => {
			console.log('change UPI pin success');
			resolve(true);
		};
		window.callbackChangePinFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '159';
		nativeData.selectedAccount = bankData;
		sendRawNativeData(nativeData);
	});
};

export const UPIRemoveBankAccount = (bankData: IUserBank) => {
	return new Promise((resolve, reject) => {
		window.callbackRemoveAccountSuccess = () => {
			console.log('remove account success');
			resolve(true);
		};
		window.callbackRemoveAccountFailed = (error: any, errorCode: any) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '160';
		nativeData.selectedAccount = bankData;
		sendRawNativeData(nativeData);
	});
};

export const manageMandate = (mandateDetails: any, selectedAccount: any) => {
	return new Promise((resolve, reject) => {
		window.callbackMandateSuccess = (details: string) => {
			console.log('vpaDetailsString', details);
			const DetailsObj = details && JSON.parse(details);
			console.log('vpaDetails', DetailsObj);
			resolve(DetailsObj);
		};
		window.callbackMandateFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '163';
		nativeData.mandateDetails = mandateDetails;
		nativeData.selectedAccount = selectedAccount;
		sendRawNativeData(nativeData);
	});
};

export const openDeepLinkWithCallback = (deepLink: string, callback?: (key?: string) => void) => {
	let finalDeepLink = deepLink;

	if (deepLink?.toString().includes('dynamic')) {
		finalDeepLink = `${deepLink}&resultCode=true`;
	}

	NativeSupportHandlerV2.openSimBindingDeepLink(finalDeepLink)
		.then(() => callback && callback())
		.catch(() => {
			console.error('Auto Refresh failed');
		});
};

export const openSettings = (deepLink: string, callback?: (key?: string) => void) => {
	let finalDeepLink = deepLink;

	if (deepLink?.toString().includes('dynamic')) {
		finalDeepLink = `${deepLink}&resultCode=true`;
	}

	NativeSupportHandlerV2.openAppSettings()
		.then(() => callback && callback())
		.catch(() => {
			console.error('Auto Refresh failed');
		});
};

export const TriggerNativeApiWrapper = (url: string, method: string, params: IObjectType, Headers: IObjectType) => {
	return new Promise<any>((resolve, reject) => {
		window.callbackUPIWrapperSuccess = (response: string) => {
			console.log('responseString', response);
			const responseObj: any = response && JSON.parse(response);
			resolve(responseObj);
		};
		window.callbackUPIWrapperFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const appInfo = getAppInfo();

		const nativeData: any = {
			url,
			method,
			params,
			Headers: { ...Headers, token: appInfo?.token },
			apiKey: 'kbj',
		};
		nativeData.key = '154';
		sendRawNativeData(nativeData);
	});
};

export const RaiseUpiComplaint = (data: any) => {
	return new Promise<IUpiComplaintDetail>((resolve, reject) => {
		window.callbackRaiseComplaintSuccess = (txnDetails: string) => {
			console.log('txnDetailsString', txnDetails);
			const txnDetailsObj: IUpiComplaintDetail = txnDetails && JSON.parse(txnDetails);
			resolve(txnDetailsObj);
		};
		window.callbackRaiseComplaintFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const { reason_code, remark, oriSeqNo } = data;
		const nativeData: any = {
			reasonCode: reason_code,
			remark,
			oriSeqNo,
		};
		nativeData.key = '165';
		sendRawNativeData(nativeData);
	});
};

export const fetchDeviceBindedNumber = () => {
	return new Promise((resolve, reject) => {
		window.callbackGetBindedMobileSuccess = (mobile: string) => {
			console.log('mobile', mobile);
			resolve({
				mobile: mobile,
			});
		};
		window.callbackGetBindedMobileFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '166';
		sendRawNativeDataUpi(nativeData, resolve, reject);
	});
};

export const CollectAuth = (txnPayload: any, note: string, selectedAccount: any, action: string, callback?: any) => {
	return new Promise<ICollectRequestDetails>((resolve, reject) => {
		// window.callbackCLRequestSubmitted = (data: any, error: string, errorCode: string) => {
		// 	console.log('payvpa:', data);
		// 	callback?.({ data, error: '', errorCode: '' });
		// 	if (error || errorCode) {
		// 		console.log('error: ', error, 'errorCode :', errorCode);
		// 		reject(modifyErrorMessage(error, errorCode));
		// 	}
		// };
		window.callbackCollectAuthSuccess = (txnDetails: string) => {
			console.log('txnDetailsString', txnDetails);
			const txnDetailsObj: ICollectRequestDetails = txnDetails && JSON.parse(txnDetails);
			console.log('txnDetails', txnDetailsObj);
			resolve(txnDetailsObj);
		};
		window.callbackCollectAuthFailed = (txnID: string, error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ txnID, error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.key = '169';
		nativeData.note = note;
		nativeData.transactionRequest = txnPayload;
		nativeData.selectedAccount = selectedAccount;
		nativeData.action = action;
		sendRawNativeDataUpi(nativeData, resolve, reject);
	});
};

export const getPendingRequest = (txnPayload: any) => {
	return new Promise<ICollectRequest>((resolve, reject) => {
		window.callbackGetPendingCollectAPISuccess = (txnDetails: string) => {
			console.log('txnDetailsString', txnDetails);
			const txnDetailsObj: ICollectRequest = txnDetails && JSON.parse(txnDetails);
			console.log('txnDetails', txnDetailsObj);
			resolve(txnDetailsObj);
		};
		window.callbackGetPendingCollectAPIFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = { ...txnPayload };
		nativeData.key = '170';
		sendRawNativeData(nativeData);
	});
};

export const DelinkBharatPeUPI = (profileId: string) => {
	return new Promise((resolve, reject) => {
		window.callbackDelinkUserSuccess = () => {
			resolve(true);
		};
		window.callbackDelinkUserFailed = (error: string, errorCode: string) => {
			console.log('error: ', error, 'errorCode:', errorCode);
			reject({ error: error, errorCode: errorCode });
		};
		const nativeData: any = {};
		nativeData.profileId = profileId;
		nativeData.key = '171';
		sendRawNativeData(nativeData);
	});
};
